import React, { useEffect, useState } from 'react';

function TruncateFileNameMiddle(fileName, maxLength = 34) {
    if (!fileName || fileName.length <= maxLength) return fileName;

    const dotIndex = fileName.lastIndexOf('.');
    const hasExtension = dotIndex > 0 && dotIndex < fileName.length - 1;

    if (!hasExtension) {
        return `${fileName.slice(0, maxLength - 1)}…`;
    }

    const extension = fileName.slice(dotIndex);
    const baseName = fileName.slice(0, dotIndex);

    // If extension is too long, keep the end of the string only.
    if (extension.length >= maxLength - 2) {
        return `…${fileName.slice(-(maxLength - 1))}`;
    }

    const charsForBase = maxLength - extension.length - 1;
    const startChars = Math.ceil(charsForBase / 2);
    const endChars = Math.floor(charsForBase / 2);

    return `${baseName.slice(0, startChars)}…${baseName.slice(-endChars)}${extension}`;
}

export default TruncateFileNameMiddle;